import React from 'react';
import styled, { css } from 'styled-components';

import PrepaymentInput from '@/components/PrepaymentInput';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  selectCreditInitialValuesData,
  selectCreditPrepayment,
  setCreditPrepayment,
} from '@/store/reducers/detailed-car';
import { maxPrepayment } from '@/components/modals/CreditModal/constants';
import { media } from '@/utils/mixin';

import { PrepaymentProps } from './types';

function Prepayment({ creditType, price }: PrepaymentProps) {
  const dispatch = useTypedDispatch();
  const creditPrepayment = useTypedSelector(selectCreditPrepayment);
  const creditInitialValuesData = useTypedSelector(
    selectCreditInitialValuesData
  );

  return (
    <Component>
      <PrepaymentInput
        total={price}
        min={
          creditInitialValuesData?.[
            creditType === 'credit' ? 'CREDIT' : 'LEASING'
          ]?.minPrepayment ?? 0
        }
        max={maxPrepayment}
        value={creditPrepayment}
        onChange={(value) => dispatch(setCreditPrepayment(value))}
      />
    </Component>
  );
}

export default Prepayment;

const Component = styled.div`
  flex: 1 1 35%;
  max-width: 35%;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
  `)}
`;
